import { Outlet, useNavigate, useLocation, matchPath } from 'react-router-dom';
import { Button } from '@dreamtree-org/twreact-ui';
import { Handshake, ExternalLink } from 'lucide-react';
import { useAppApi } from '@/lib/api';
import { StaffShell } from '@/components';
import { vendorRoutes } from './routes';
import { useVendorSession } from './VendorApp';

/** Vendor portal shell (StaffShell): sidebar on desktop, tab bar on phones. */
export default function VendorLayout({ store }) {
  const nav = useNavigate();
  const loc = useLocation();
  const { vendor, reload } = useVendorSession();
  const { fetchApi } = useAppApi();

  const isActive = (r) => matchPath({ path: r.path, end: true }, loc.pathname);
  const navRoutes = vendorRoutes.filter((r) => r.nav);
  const current = navRoutes.find(isActive);
  const icon = (r, size) => <r.icon size={size} aria-hidden />;
  const storeName = (store && store.name) || 'MerchantPro';

  const logout = async () => {
    try {
      await fetchApi('vendorSignOut');
    } catch {
      /* the session may already be gone */
    }
    nav('/login', { replace: true });
    reload();
  };

  return (
    <StaffShell
      brand={
        <span className="min-w-0">
          <span className="block font-semibold truncate">{storeName}</span>
          <span className="inline-flex items-center gap-1 text-micro opacity-70"><Handshake size={12} aria-hidden /> Vendor portal</span>
        </span>
      }
      pageTitle={current ? current.label : 'Vendor portal'}
      nav={navRoutes.map((r) => ({ id: r.path, label: r.label, href: r.path, icon: icon(r, 18), active: !!isActive(r) }))}
      foot={navRoutes.filter((r) => r.foot).map((r) => ({ id: r.path, label: r.short || r.label, to: r.path, icon: icon(r, 20), active: !!isActive(r) }))}
      user={vendor ? { name: vendor.business_name, email: vendor.email } : null}
      onLogout={logout}
      actions={
        <Button as="a" href="/" variant="ghost" size="icon" aria-label="View storefront" title="View storefront">
          <ExternalLink size={18} aria-hidden />
        </Button>
      }
    >
      <Outlet />
    </StaffShell>
  );
}
